import gql from 'graphql-tag';

const WDT_STUDENT_SETTINGS_FRAGMENT = gql`
  fragment BaseWdtStudentSettings on WdtStudentSettings {
    handedness {
      leftHanded
      rtlCrossStroke
    }
    characterOrder {
      numbers
      capitals
      lowercase
    }
  }
`;

export default WDT_STUDENT_SETTINGS_FRAGMENT;
